import { Link } from 'react-router-dom';
import { celebrityTracking } from '@/mocks/homeData';

export default function TrackingSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-screen-2xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
            网红<span className="text-accent-500">塌房</span>追踪
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            实时追踪网红塌房事件，完整时间线复盘
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {celebrityTracking.map((item) => (
            <Link
              key={item.id}
              to="/"
              className="group cursor-pointer"
            >
              <div className="rounded-lg overflow-hidden border border-foreground-200/40 bg-background-50 transition-all duration-300 group-hover:border-accent-300/60">
                <div className="relative h-[240px] md:h-[280px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent h-20" />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-label mb-3">
                    {item.category}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors duration-200">
                    {item.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}